// ヘッダーメニューのカレント表示
function indicateCurrentMenuItem() {
  // 現在のURLパスから親階層の名前を取得
  const pathParts = window.location.pathname.split('/').filter((part) => part.length > 0);
  const isHomePage = pathParts.length === 0; // トップページかどうか
  
  // post_typeクエリパラメータを取得（月別アーカイブ対応）
  const urlParams = new URLSearchParams(window.location.search);
  const postType = urlParams.get('post_type');
  
  // パスから親slugを取得（カテゴリーページの場合は親slugに変換）
  let parentSlug = pathParts[0];
  if (postType === 'blog' || postType === 'news') {
    // 月別アーカイブの場合、post_typeを優先
    parentSlug = postType;
  } else if (parentSlug === 'tag') {
    // タグページはブログに紐づいているため、blogとして扱う
    parentSlug = 'blog';
  } else if (parentSlug === 'blog-category') {
    parentSlug = 'blog';
  } else if (parentSlug === 'news-category') {
    parentSlug = 'news';
  }

  // data-parent-slug 属性を持つメニュー項目をループしてマッチするものを探す
  const menuItems = document.querySelectorAll('[data-parent-slug]');
  menuItems.forEach((item) => {
    const dataParentSlug = item.getAttribute('data-parent-slug');
    const parentSlugs = dataParentSlug
      .split(',')
      .map((slug) => slug.trim());
    
    // トップページの場合：data-parent-slugが空文字列のアイテムを強調
    // それ以外の場合：parentSlugが一致するアイテムを強調
    if ((isHomePage && dataParentSlug === '') || (!isHomePage && parentSlugs.includes(parentSlug))) {
      // 強調表示のためのクラスを追加
      item.querySelector('a').classList.add('is-paged');
    }
  });
}


// sub-fvの存在を確認してクラスを付与
function checkSubFvAndApplyWhiteClass() {
  subFv = document.querySelector('.js-sub-fv');
  
  if (subFv) {
    // sub-fvが存在する場合、bodyにhas-sub-fvクラスを追加
    document.body.classList.add('has-sub-fv');
  }
}

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  indicateCurrentMenuItem();
  // checkSubFvAndApplyWhiteClass();
});

